import React from 'react';

function NotFoundPage(props) {
    return (
        <div className='not_found'>
            <h1>Не найдено: 
            404 </h1>
            <a href='/'> ← Вернуться на главную страницу</a>
        </div>
    );
}

export default NotFoundPage;